import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { dateRange, initials } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function IconSidebarTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-relaxed flex overflow-hidden" data-testid="resume-live-preview">
      <div className="w-[34%] p-5" style={{ backgroundColor: `${accent}12` }}>
        <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-sm mb-3" style={{ backgroundColor: accent }}>{initials(draft.full_name)}</div>
        <h1 className="text-base font-bold text-slate-900">{draft.full_name || "Your Name"}</h1>
        <div className="text-slate-600 text-[10px] mt-2 space-y-1">
          {draft.contact_email && <p className="flex items-center gap-1"><Mail className="w-3 h-3" />{draft.contact_email}</p>}
          {draft.contact_phone && <p className="flex items-center gap-1"><Phone className="w-3 h-3" />{draft.contact_phone}</p>}
          {draft.location && <p className="flex items-center gap-1"><MapPin className="w-3 h-3" />{draft.location}</p>}
        </div>
        {draft.skills.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[10px] font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
            <div className="flex flex-wrap gap-1">{draft.skills.map((sk) => <span key={sk} className="text-[9px] font-medium px-2 py-0.5 rounded-full bg-white border" style={{ borderColor: `${accent}40`, color: accent }}>{sk}</span>)}</div>
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[10px] font-bold uppercase tracking-wider mb-1.5" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 text-[10px] mt-1">{ed.degree} {ed.field}<br />{ed.school}</p>)}
          </div>
        )}
      </div>
      <div className="w-[66%] p-6">
        {draft.target_role && <p className="text-slate-500 text-xs font-semibold uppercase tracking-wide">{draft.target_role}</p>}
        {draft.summary && <p className="text-slate-700 mt-2">{draft.summary}</p>}
        {draft.experience.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
